var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 6,
    fill: "#88D4FF",
    stroke: "#88D4FF",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_151_127372",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_151_127372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 33.3332C10.8889 33.3332 9.94444 32.9443 9.16667 32.1665C8.38889 31.3887 8 30.4443 8 29.3332V25.3332H12V6.6665H32V29.3332C32 30.4443 31.6111 31.3887 30.8333 32.1665C30.0556 32.9443 29.1111 33.3332 28 33.3332H12ZM28 30.6665C28.3778 30.6665 28.6944 30.5387 28.95 30.2832C29.2056 30.0276 29.3333 29.7109 29.3333 29.3332V9.33317H14.6667V25.3332H26.6667V29.3332C26.6667 29.7109 26.7944 30.0276 27.05 30.2832C27.3056 30.5387 27.6222 30.6665 28 30.6665ZM16 15.9998V13.3332H28V15.9998H16ZM16 19.9998V17.3332H28V19.9998H16ZM12 30.6665H24V27.9998H10.6667V29.3332C10.6667 29.7109 10.7944 30.0276 11.05 30.2832C11.3056 30.5387 11.6222 30.6665 12 30.6665ZM12 30.6665H10.6667H24H12Z",
    fill: "#002E40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveContract);
export default __webpack_public_path__ + "static/media/ActiveContract.ab68898e7ad76db0ffccdd73c53d002c.svg";
export { ForwardRef as ReactComponent };